module.exports = __webpack_public_path__ + "media/images/area/area_hokkaidoM400-6646a007ef010d1f766f03c4cbcfd28f.jpg";